import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from "@mui/material/FormGroup";
import * as dates from '@simplybenefits/sb-dates';
import { Loader, TextInput, DateInput, Services, Button, Text, Theme, Checkbox, i18n, tokens } from '@simplybenefits/sb-ui-library';

import { globalStyles } from '../../../theme/index.js';
import Tip from '../../../components/Tip.js';

class Signage extends PureComponent {
    state = {
        name: '',
        signature: '',
        acceptedTerms: false,
        timestampOfAcceptance: null,
        datedOn: null
    };

    componentDidMount() {
        this.setState({
            name: '',
            signature: '',
            acceptedTerms: false,
            timestampOfAcceptance: null,
            datedOn: null
        });
    }

    _isSignageCompleted = async () => {
        const { name, signature, datedOn, acceptedTerms } = this.state;

        let signageNameError = await Services.validateInput('checkEmpty', name);
        const signageSignatureError = await Services.validateInput('checkEmpty', signature);
        const signageDatedOnError = await Services.validateInput('date', datedOn, i18n.locale);
        const signageAcceptedError = !acceptedTerms;

        if (name !== signature) {
            signageNameError = i18n.t(tokens.labels.signage.signageNameError);
        }

        if (signageAcceptedError) {
            alert(i18n.t(tokens.labels.signage.pleaseAcceptAndAcknowledgeChanges));
        }

        this.setState({
            signageNameError,
            signageSignatureError,
            signageDatedOnError
        });

        if (
            signageNameError ||
            signageSignatureError ||
            signageDatedOnError ||
            signageAcceptedError
        ) {
            return false;
        }

        return true;
    };

    _handleInputChange = (type, value) => {
        if (type === 'acceptedTerms' && value === true) {
            this.setState({
                acceptedTerms: true,
                timestampOfAcceptance: dates.getUTC()
            });

            return null;
        }

        this.setState({
            [type]: value
        });

        return null;
    };

    _finish = async () => {
        const isSignageComplete = await this._isSignageCompleted();

        if (!isSignageComplete) {
            return false;
        }

        this.props.stepCompletion({
            name: this.state.name.trim(),
            signature: this.state.signature.trim(),
            acceptedTerms: this.state.acceptedTerms,
            timestampOfAcceptance: this.state.timestampOfAcceptance,
            datedOn: Services.dates.formatOutgoingDate(this.state.datedOn)
        }, 'signage', true);

        return true;
    };

    render() {

        const styles = {
            form: {
                display: 'flex',
                flexDirection: 'column'
            },
            stepperBackBtn: {
                margin: '0px auto 0px 0px !important'
            },
            stepperNextBtn: globalStyles.stepperNextBtn,
            stepperBtnContainer: globalStyles.stepperBtnContainer
        };

        return (
            <div>
                {
                    this.props.loader?.isLoading && <Loader/>
                }
                <Text largest bold margin="0 0 10px 0">{ i18n.t(tokens.labels.confirmation) }</Text>

                <div style={styles.form}>
                    <Tip
                        left
                        show={ this.props.tips.spendingAccountBreakdown }
                        close={ () => this.props.hideTip('spendingAccountBreakdown') }
                        customStyle={{ marginTop: -100 }}
                    >
                        { i18n.t(tokens.labels.signup.finishedFillingOutEnrolmentForm) } <span style={{ fontWeight: 'bold' }}>{ i18n.t(tokens.labels.signup.readyToSubmitYourDetails) },</span>&nbsp;
                        { i18n.t(tokens.labels.signup.provideNameESignatureDateAndClick) } <span style={{ fontWeight: 'bold' }}>{ i18n.t(tokens.labels.signup.finish) }</span>&nbsp;
                        { i18n.t(tokens.labels.signup.completeYourEnrolmentButton) }
                    </Tip>

                    <FormGroup row style={{ marginTop: 20 }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={ this.state.acceptedTerms }
                                    onChange={ () => this._handleInputChange('acceptedTerms', !this.state.acceptedTerms) }
                                    value="acceptedTerms"
                                    color="secondary"
                                />
                            }
                            sx={{ "& .MuiTypography-root": { fontFamily: Theme.fonts.type.medium, color: Theme.colors.mainTextGrey } }}
                            label={ i18n.t(tokens.labels.account.acknowledgeInfoAccuracy) }
                        />
                    </FormGroup>

                    <TextInput
                        label={ i18n.t(tokens.labels.yourName) }
                        fullWidth
                        value={this.state.name}
                        onChange={(e) => this._handleInputChange('name', e.target.value)}
                        error={ this.state.signageNameError }
                    />

                    <TextInput
                        label={ i18n.t(tokens.labels.signature) }
                        fullWidth
                        value={this.state.signature}
                        onChange={(e) => this._handleInputChange('signature', e.target.value)}
                        isSignature={true}
                        error={ this.state.signageSignatureError }
                    />

                    <DateInput
                        label={ i18n.t(tokens.labels.account.datedOnYYYYMMDD)}
                        fullWidth
                        value={this.state.datedOn}
                        onChange={(e) => this._handleInputChange('datedOn', e.target.value)}
                        error={ this.state.signageDatedOnError }
                    />

                    <div style={styles.stepperBtnContainer}>
                        <Button
                            style={styles.stepperNextBtn}
                            onClick={this._finish}
                            color="primary"
                        >
                            { i18n.t(tokens.buttons.finish) }
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default (connect()(Signage));